import styled from 'styled-components';
import { Colors } from '../../../config/theme';
import { ORDER_STATUS } from '../../../data/types/orders';
import { TRANSACTION_METHODS } from '../../../data/types/transactions';

export const PaymentMethodTag = styled.div`
  padding: 2px;
  span {
    padding: 5px;
    font-size: 12px;
  }

  .method {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: 0px;
    padding: 3px 9px;
    font-weight: 500;
    height: fit-content;
    font-size: 14px;
  }
  .method-${TRANSACTION_METHODS.cash} {
    background: ${Colors.tomatoRedLight};
    color: ${Colors.tomatoRed};
  }
  .method-${TRANSACTION_METHODS.card} {
    background: #e3fcef;
    color: #006644;
  }
  .method-${TRANSACTION_METHODS.mobile_payment} {
    background: #fffae6;
    color: #ff8b00;
  }
  .method-${TRANSACTION_METHODS.bank_transfer} {
    background: purple;
    color: white;
  }
  .method-${TRANSACTION_METHODS.debt} {
    background: crimson;
    color: white;
  }
  .method-${TRANSACTION_METHODS.balance_credit} {
    background: #f3f3f3;
    color: #333;
  }
`;

export const DeliveryMethodTag = styled.div`
  .method {
    border-radius: 5px;
    padding: 3px 9px;
    font-weight: 500;
    height: fit-content;
    font-size: 14px;
    &.delivery {
      background: #0065ff;
      color: #fff;
    }
    &.pickup {
      background: #6554c0;
      color: #fff;
    }
  }
`;

export const StatusTag = styled.div`
  border-radius: 8px;
  padding: 2px;
  /* Requested */
  .status-${ORDER_STATUS.requested} {
    background: #8e44ad; /* Amethyst Purple */
    color: #fff;
  }

  /* Accepted */
  .status-${ORDER_STATUS.accepted} {
    background: #2ecc71; /* Emerald Green */
    color: #fff;
  }

  /* Rejected */
  .status-${ORDER_STATUS.rejected} {
    background: #e74c3c; /* Alizarin Red */
    color: #fff;
  }

  /* Cancelled */
  .status-${ORDER_STATUS.cancelled} {
    background: #f39c12; /* Sunflower Yellow */
    color: #fff;
  }

  /* Delivered */
  .status-${ORDER_STATUS.delivered} {
    background: #3498db; /* Peter River Blue */
    color: #fff;
  }

  /* Returned */
  .status-${ORDER_STATUS.returned} {
    background: #9b59b6; /* Amethyst Purple */
    color: #fff;
  }

  /* Ship - In Store - Ready */
  .status-${ORDER_STATUS.ship__in_store__ready} {
    background: #27ae60; /* Nephritis Green */
    color: #fff;
  }

  /* Ship - In Transit - To Silal */
  .status-${ORDER_STATUS.ship__in_transit__to_silal} {
    background: #e67e22; /* Carrot Orange */
    color: #fff;
  }

  /* Ship - At Silal - Ready */
  .status-${ORDER_STATUS.ship__at_silal__ready} {
    background: #1abc9c; /* Turquoise Green */
    color: #fff;
  }

  /* Ship - In Transit - To Customer */
  .status-${ORDER_STATUS.ship__in_transit__to_customer} {
    background: #3498db; /* Peter River Blue */
    color: #fff;
  }

  /* Ship - In Store - Waiting Pickup Reschedule */
  .status-${ORDER_STATUS.ship__in_store__waiting_pickup_reschedule} {
    background: #f1c40f; /* Sunflower Yellow */
    color: #fff;
  }

  /* Ship - In Transit - Failed Dropoff to Customer */
  .status-${ORDER_STATUS.ship__in_transit__failed_dropoff_to_customer} {
    background: #e74c3c; /* Alizarin Red */
    color: #fff;
  }

  /* Ship - At Silal - Waiting Dropoff Reschedule */
  .status-${ORDER_STATUS.ship__at_silal__waiting_dropoff_reschedule} {
    background: #e67e22; /* Carrot Orange */
    color: #fff;
  }

  /* Return - With Customer - Waiting Self Dropoff */
  .status-${ORDER_STATUS.return__with_customer__waiting_self_dropoff} {
    background: #f39c12; /* Sunflower Yellow */
    color: #fff;
  }

  /* Return - With Customer - Ready */
  .status-${ORDER_STATUS.return__with_customer__ready} {
    background: #2ecc71; /* Emerald Green */
    color: #fff;
  }

  /* Return - In Transit - To Silal */
  .status-${ORDER_STATUS.return__in_transit__to_silal} {
    background: #3498db; /* Peter River Blue */
    color: #fff;
  }

  /* Return - In Transit - To Store */
  .status-${ORDER_STATUS.return__in_transit__to_store} {
    background: #e74c3c; /* Alizarin Red */
    color: #fff;
  }

  /* Return - At Silal - Ready */
  .status-${ORDER_STATUS.return__at_silal__ready} {
    background: #27ae60; /* Nephritis Green */
    color: #fff;
  }

  /* Return - At Silal - Waiting Inspection */
  .status-${ORDER_STATUS.return__at_silal__waiting_inspection} {
    background: #9b59b6; /* Amethyst Purple */
    color: #fff;
  }

  /* Return - At Silal - Return Rejected */
  .status-${ORDER_STATUS.return__at_silal__return_rejected} {
    background: #e67e22; /* Carrot Orange */
    color: #fff;
  }

  /* Return - At Silal - Waiting Schedule */
  .status-${ORDER_STATUS.return__at_silal__waiting_schedule} {
    background: #f1c40f; /* Sunflower Yellow */
    color: #fff;
  }

  /* Return - In Transit - Failed Dropoff to Store */
  .status-${ORDER_STATUS.return__in_transit__failed_dropoff_to_store} {
    background: #e74c3c; /* Alizarin Red */
    color: #fff;
  }
`;

export const OrderList = styled.div`
  overflow-x: auto;
  padding-right: 15px;
  .head {
    display: flex;
    h3 {
      margin: 0 0 10px 0;
      font-weight: 500;
      font-size: 13px;
      color: #4c6870;
    }
    .item-width {
      min-width: 200px;
      flex: 2;
    }
    .col-width {
      min-width: 60px;
      flex: 1;
      &.right {
        text-align: right;
      }
    }
  }
`;

export const OrderListItemStyled = styled.div`
  padding: 15px 0;
  border-bottom: 1px solid #ebeeef;
  &:last-of-type {
    border: none;
  }
  img {
    height: 64px;
    width: 64px;
    min-width: 64px;
    border-radius: 5px;
    object-fit: cover;
    margin-right: 10px;
  }
  h6 {
    font-weight: normal;
    font-size: 13px;
    color: #002733;
    margin: 0;
    &.pr-2 {
      padding-right: 10px;
    }
  }
  .item-width {
    min-width: 200px;
    flex: 2;
  }
  .col-width {
    min-width: 60px;
    flex: 1;
    &.right {
      text-align: right;
    }
  }
  .note-active {
    background: ${Colors.greenSecondary};
    border: 1px solid ${Colors.greenMain};
    border-radius: 5px;
    border-radius: 5px;
    padding: 10px 14px;
    margin-top: 15px;
    font-weight: 500;
    font-size: 13px;
    color: ${Colors.greenMain};
    span {
      color: #4c6870;
    }
  }

  .note-inactive {
    background: ${Colors.grayLight};
    border: 1px solid ${Colors.grey};
    border-radius: 5px;
    border-radius: 5px;
    padding: 10px 14px;
    margin-top: 15px;
    font-weight: 500;
    font-size: 13px;
    color: #4c6870;
  }
  .customization {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    margin-left: 9%;
    width: 91%;
    &:first-of-type {
      border-top: 1px solid #ebeeef;
    }
    .item-width {
      h5 {
        padding-left: 75px;
      }
    }
    span {
      width: 63px;
      height: 17px;
      background: #f2a341;
      border-radius: 3px;
      font-weight: normal;
      font-size: 9px;
      color: white;
    }
    h5 {
      font-weight: normal;
      font-size: 12px;
      color: #002733;
      margin: 0;
    }
  }
`;
